module.exports = __webpack_public_path__ + "static/media/download.fb3f7a0f.svg";